import { useEffect, useState } from "react";
import { getPublicSiteTextsApiPath } from "../utils/publicSiteConfigPaths";

export const PUBLIC_SITE_TEXT_DEFAULTS = {
  heroTitle: "Formación online de calidad",
  heroSubtitle: "Prepárate con una plataforma clara, intuitiva y siempre actualizada",
  coursesSectionTitle: "Nuestros cursos",
  coursesCtaLabel: "Ver todos los cursos",
  benefitsTitle: "¿Por qué estudiar con nosotros?",
  benefit1Title: "📚 Contenido actualizado",
  benefit1Description: "Material revisado y adaptado a las convocatorias.",
  benefit2Title: "🧠 Metodología eficaz",
  benefit2Description: "Temario, resúmenes y test actualizados.",
  benefit3Title: "⏳ Estudia a tu ritmo",
  benefit3Description: "Accede cuando quieras. Tú decides cuándo y cómo avanzar.",
  benefit4Title: "🎧 Soporte y acompañamiento",
  benefit4Description: "Te guiamos en cada paso de tu preparación.",
  learningTitle: "Descubre una nueva forma de aprender",
  learningDescription:
    "Nuestros cursos están diseñados para que aproveches cada minuto de estudio al máximo. Accede a contenidos claros, prácticos y constantemente actualizados. Ya seas principiante o tengas experiencia, encontrarás un camino hecho para ti.",
  learningHighlight: "Empieza hoy y da el primer paso hacia tu nuevo futuro.",
  howItWorksTitle: "¿Cómo funciona la plataforma?",
  step1Title: "Accede al curso",
  step1Description: "Inscríbete y entra al contenido desde cualquier dispositivo.",
  step2Title: "Estudia el temario",
  step2Description: "Contenido claro, organizado y siempre actualizado.",
  step3Title: "Haz test y repasa",
  step3Description: "Evalúa tu progreso con test reales y repasos rápidos.",
  step4Title: "Mejora tus resultados",
  step4Description: "Detecta fallos y avanza con seguridad.",
  testimonialsTitle: "Lo que opinan nuestros alumnos",
  testimonialsFallbackText:
    "La plataforma es muy intuitiva y el temario está muy bien estructurado. Me ha ayudado a estudiar con constancia.",
  testimonialsFallbackAuthor: "Laura M.",
  ctaTitle: "Tu futuro empieza con una decisión",
  ctaSubtitle:
    "Miles de estudiantes ya han confiado en nuestra plataforma para avanzar profesionalmente. ¿Listo para comenzar?",
  ctaButtonLabel: "Acceder al campus virtual",
};

function mergePublicTexts(data) {
  const merged = { ...PUBLIC_SITE_TEXT_DEFAULTS };
  if (!data || typeof data !== "object") return merged;
  for (const key of Object.keys(PUBLIC_SITE_TEXT_DEFAULTS)) {
    const val = data[key];
    if (typeof val === "string" && val.trim()) {
      merged[key] = val.trim();
    }
  }
  return merged;
}

export default function usePublicSiteTexts() {
  const [texts, setTexts] = useState(PUBLIC_SITE_TEXT_DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const res = await fetch(getPublicSiteTextsApiPath(), {
          credentials: "include",
          signal: controller.signal,
        });
        if (res.ok) {
          const data = await res.json();
          if (!controller.signal.aborted) {
            setTexts(mergePublicTexts(data));
          }
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          setTexts(PUBLIC_SITE_TEXT_DEFAULTS);
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    })();
    return () => controller.abort();
  }, []);

  return { texts, loading };
}
